import { XMarkIcon } from '@heroicons/react/24/outline';
import { Tooltip } from '@odo/shared-ui';
import { categoryTone } from './categories';

interface CategoryChipProps {
    id: string;
    onRemove?: () => void;
    /** Caps the label's own width so the chip self-clips instead of relying
     *  on an ancestor - the table cell needs this, the form's wrapping row doesn't. */
    maxLabelWidth?: string;
}

// A selected category - dot in the category's own tone + label, with an ×
// to unlink when removable. Matches the app's other small pill chips
// (patient chips, reference pill).
export function CategoryChip({ id, onRemove, maxLabelWidth }: CategoryChipProps) {
    return (
        <span className="inline-flex items-center gap-1.5 rounded-full bg-gray-50 border border-gray-200 text-gray-700 font-semibold text-[11px] h-6 px-2 whitespace-nowrap">
            <span
                className="w-1.5 h-1.5 rounded-full shrink-0"
                style={{ background: categoryTone(id) }}
            />
            {maxLabelWidth ? (
                <Tooltip content={id}>
                    <span className="truncate" style={{ maxWidth: maxLabelWidth }}>
                        {id}
                    </span>
                </Tooltip>
            ) : (
                id
            )}
            {onRemove && (
                <button
                    type="button"
                    onClick={(e) => {
                        e.stopPropagation();
                        onRemove();
                    }}
                    aria-label={`Remove ${id}`}
                    className="opacity-60 hover:opacity-100 shrink-0"
                >
                    <XMarkIcon className="h-3 w-3" />
                </button>
            )}
        </span>
    );
}
